/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GalleryNotifications: BridgeCommands.Command<
    {},
    Types.Common.Gallery.GalleryNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GalleryNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const MontageNotification: BridgeCommands.Command<
    {},
    Types.Common.Gallery.MontageNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'MontageNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PathChangeNotification: BridgeCommands.Command<
    {},
    Types.Common.Gallery.PathChangeNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'PathChangeNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const TempFolderChangeNotification: BridgeCommands.Command<
    {},
    Types.Common.Gallery.TempFolderChangeNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'TempFolderChangeNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GalleryCapStateChangeNotification: BridgeCommands.Command<
    {},
    Types.Common.Gallery.GalleryCapStateChangeNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GalleryCapStateChangeNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GalleryUpdatedNotification: BridgeCommands.Command<
    {},
    Types.Common.Gallery.GalleryUpdatedNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GalleryUpdatedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFolderListing: BridgeCommands.Command<
    Types.Common.Gallery.GetFolderListingParameters,
    Types.Common.Gallery.GetFolderListingReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetFolderListing',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAppStats: BridgeCommands.Command<
    Types.Common.Gallery.GetAppStatsParameters,
    Types.Common.Gallery.GetAppStatsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetAppStats',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAppUGC: BridgeCommands.Command<
    Types.Common.Gallery.GetAppUGCParameters,
    Types.Common.Gallery.GetAppUGCReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetAppUGC',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RemoveGalleryItem: BridgeCommands.Command<
    Types.Common.Gallery.RemoveGalleryItemParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'RemoveGalleryItem',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnumerateDrives: BridgeCommands.Command<
    {},
    Types.Common.Gallery.EnumerateDrivesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'EnumerateDrives',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFileMetadata: BridgeCommands.Command<
    Types.Common.Gallery.GetFileMetadataParameters,
    Types.Common.Gallery.GetFileMetadataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetFileMetadata',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetEventData: BridgeCommands.Command<
    {},
    Types.Common.Gallery.GetEventDataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetEventData',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetThumbnail: BridgeCommands.Command<
    Types.Common.Gallery.GetThumbnailParameters,
    Types.Common.Gallery.GetThumbnailReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetThumbnail',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFolderCRC: BridgeCommands.Command<
    Types.Common.Gallery.GetFolderCRCParameters,
    Types.Common.Gallery.GetFolderCRCReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetFolderCRC',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetImageFileDimensions: BridgeCommands.Command<
    Types.Common.Gallery.GetImageFileDimensionsParameters,
    Types.Common.Gallery.GetImageFileDimensionsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetImageFileDimensions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CopyFile: BridgeCommands.Command<
    Types.Common.Gallery.CopyFileParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'CopyFile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const MoveFile: BridgeCommands.Command<
    Types.Common.Gallery.MoveFileParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'MoveFile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsDirectoryWriteable: BridgeCommands.Command<
    Types.Common.Gallery.IsDirectoryWriteableParameters,
    Types.Common.Gallery.IsDirectoryWriteableReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'IsDirectoryWriteable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSettings: BridgeCommands.Command<
    {},
    Types.Common.Gallery.GetSettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetSettings: BridgeCommands.Command<
    Types.Common.Gallery.SetSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'SetSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDriveInfo: BridgeCommands.Command<
    Types.Common.Gallery.GetDriveInfoParameters,
    Types.Common.Gallery.GetDriveInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetDriveInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CancelPathUpdate: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'CancelPathUpdate',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRecentUGC: BridgeCommands.Command<
    Types.Common.Gallery.GetRecentUGCParameters,
    Types.Common.Gallery.GetRecentUGCReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetRecentUGC',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CheckDiskSpace: BridgeCommands.Command<
    {},
    Types.Common.Gallery.CheckDiskSpaceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'CheckDiskSpace',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnqueuePendingHighlight: BridgeCommands.Command<
    Types.Common.Gallery.EnqueuePendingHighlightParameters,
    Types.Common.Gallery.EnqueuePendingHighlightReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'EnqueuePendingHighlight',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenHighlightsGroupSummary: BridgeCommands.Command<
    Types.Common.Gallery.OpenHighlightsGroupSummaryParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'OpenHighlightsGroupSummary',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHighlightsCount: BridgeCommands.Command<
    Types.Common.Gallery.GetHighlightsCountParameters,
    Types.Common.Gallery.GetHighlightsCountReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetHighlightsCount',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeleteGroupHighlights: BridgeCommands.Command<
    Types.Common.Gallery.DeleteGroupHighlightsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'DeleteGroupHighlights',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const WriteEncryptedBitmap: BridgeCommands.Command<
    Types.Common.Gallery.WriteEncryptedBitmapParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'WriteEncryptedBitmap',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const TranscodeMediaFile: BridgeCommands.Command<
    Types.Common.Gallery.TranscodeMediaFileParameters,
    Types.Common.Gallery.TranscodeMediaFileReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'TranscodeMediaFile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CreateMontage: BridgeCommands.Command<
    Types.Common.Gallery.CreateMontageParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'CreateMontage',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CreateMontageFromRecipe: BridgeCommands.Command<
    Types.Common.Gallery.CreateMontageFromRecipeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'CreateMontageFromRecipe',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CancelMontage: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'CancelMontage',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UpdateMontageProgress: BridgeCommands.Command<
    Types.Common.Gallery.UpdateMontageProgressParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'UpdateMontageProgress',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Trim: BridgeCommands.Command<
    Types.Common.Gallery.TrimParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'Trim',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AddMeme: BridgeCommands.Command<
    Types.Common.Gallery.AddMemeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'AddMeme',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EngraveMP4: BridgeCommands.Command<
    Types.Common.Gallery.EngraveMP4Parameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'EngraveMP4',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeletePreview: BridgeCommands.Command<
    Types.Common.Gallery.DeletePreviewParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'DeletePreview',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PreviewPathInfo: BridgeCommands.Command<
    Types.Common.Gallery.PreviewPathInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'PreviewPathInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMontageCloudConfig: BridgeCommands.Command<
    {},
    Types.Common.Gallery.GetMontageCloudConfigReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'GetMontageCloudConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const MigrateHighlightsTracker: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gallery',
    method: 'MigrateHighlightsTracker',
    persistent: false
};

export const Gallery = {
GalleryNotifications,
MontageNotification,
PathChangeNotification,
TempFolderChangeNotification,
GalleryCapStateChangeNotification,
GalleryUpdatedNotification,
GetFolderListing,
GetAppStats,
GetAppUGC,
RemoveGalleryItem,
EnumerateDrives,
GetFileMetadata,
GetEventData,
GetThumbnail,
GetFolderCRC,
GetImageFileDimensions,
CopyFile,
MoveFile,
IsDirectoryWriteable,
GetSettings,
SetSettings,
GetDriveInfo,
CancelPathUpdate,
GetRecentUGC,
CheckDiskSpace,
EnqueuePendingHighlight,
OpenHighlightsGroupSummary,
GetHighlightsCount,
DeleteGroupHighlights,
WriteEncryptedBitmap,
TranscodeMediaFile,
CreateMontage,
CreateMontageFromRecipe,
CancelMontage,
UpdateMontageProgress,
Trim,
AddMeme,
EngraveMP4,
DeletePreview,
PreviewPathInfo,
GetMontageCloudConfig,
MigrateHighlightsTracker
};
